module.exports = __webpack_public_path__ + "images/icons/flags/SK-ca99584c.svg";